import VendorList from '../pages/finances/vendors/VendorList';
import VendorDetail from '../pages/finances/vendors/VendorDetail';
import VendorForm from '../pages/finances/vendors/VendorForm';

const vendorRoutes = [
  {
    path: 'finances/vendors',
    element: VendorList,
    permission: 'vendors.read'
  },
  {
    path: 'finances/vendors/create',
    element: VendorForm,
    permission: 'vendors.create'
  },
  {
    path: 'finances/vendors/:id',
    element: VendorDetail,
    permission: 'vendors.read',
    exact: true
  },
  {
    path: 'finances/vendors/:id/edit',
    element: VendorForm,
    permission: 'vendors.update'
  }
];

export default vendorRoutes;